"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var index_1 = require("../../index");

require("./index.css");

var InfiniteListMessage = function (_a) {
  var iconName = _a.iconName,
      iconClass = _a.iconClass,
      iconSize = _a.iconSize,
      message = _a.message;
  var width = iconSize.width,
      height = iconSize.height;
  return (0, jsx_runtime_1.jsxs)("div", __assign({
    className: "infinite-list-message",
    "aria-label": "End of list message, " + message
  }, {
    children: [(0, jsx_runtime_1.jsx)(index_1.Icon, {
      name: iconName,
      className: iconClass,
      height: height,
      width: width
    }, void 0), (0, jsx_runtime_1.jsx)("span", __assign({
      className: "infinite-list-message__text"
    }, {
      children: message
    }), void 0)]
  }), void 0);
};

exports.default = InfiniteListMessage;